import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=b9eeff4e&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=b9eeff4e&lang=scss&scoped=true&"
import style1 from "./Faq.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9eeff4e",
  null
  
)

export default component.exports